import axios from 'axios';
import { groupBy, mergeArrsByKey } from '@/helpers';

import { httpWithLoader, http } from '@/http-common';

const state = () => ({
    areas: [], // ОПД
    notEmptyAreas: [], // ОПД
    kinds: [], // ВПД
    qualifications: [], // Квалификации
    orks: [], // Рамки
    interrelations: [], // Взаимосвязи
    work_functions: [], // Трудовые функции
    autoTrajectoryQualifications: null,
    standard: null,
});

const getters = {};

const mutations = {
    SET_AREAS(state, areas) {
        state.areas = areas
    },
    /*SET_NOT_EMPTY_AREAS(state, areas) {
        state.notEmptyAreas = areas
    },*/
    SET_KINDS(state, kinds) {
        state.kinds = kinds
    },
    SET_STANDARD(state, standard) {
        state.standard = standard;
    },
    SET_AUTO_TRAJECTORY_QUALIFICATIONS(state, qualifications) {
        state.autoTrajectoryQualifications = qualifications;
    },
    SET_QUALIFICATIONS(state, qualifications) {
        state.qualifications = qualifications
    },
    SET_ORKS(state, orks) {
        state.orks = orks
    },
    SET_INTERRELATIONS_BY_QUALIFICATION(state, interrelations) {
        state.interrelations = interrelations
    },
    SET_WORK_FUNCTIONS(state, work_functions) {
        state.work_functions = work_functions
    },
};

const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the 
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    async LOAD_AREAS({ commit, rootState }) {
        await httpWithLoader.get(`/orks/areas`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_AREAS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_AREAS_BY_QUERY({ commit, rootState }, { query, demanded }) {
        let queryS = query ? `?query=${query}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/filter-areas` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_AREAS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_ALL_AREAS({ commit, rootState }, demanded) {
        const query = demanded ? `?demanded=${demanded}` : ''

        await httpWithLoader.get(`/filter-all-areas` + query, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {

            // console.log(response.data);
/*
            if (notEmptyAreas.length === 0) {
                for (const area of response.data) {

                    let query = area.id ? `?area_id=${area.id}` : ''

                    httpWithLoader.get(`/orks/qualifications` + query, {
                        headers: {
                            'Authorization': `bearer ${rootState.tokens.accessToken}`
                        }
                    })
                    .then((response2) => {
                        if (response2.data.length > 0) {
                            notEmptyAreas.push(area);
                        }
                    })
                    .catch((reject) => {
                        handleError(reject, commit)
                    });
                }

                commit('SET_AREAS', notEmptyAreas)
                commit('SET_NOT_EMPTY_AREAS', notEmptyAreas)
            } else {*/
                commit('SET_AREAS', response.data)
            // }
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_KINDS({ commit, rootState }, area_id) {
        const query = area_id ? `?area_id=${area_id}` : ''

        await httpWithLoader.get(`/orks/kinds` + query, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_KINDS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_QUALIFICATION_AUTO_INTERRELATIONS({commit, rootState}, qualificationId) {
        await httpWithLoader.get(`/qualifications/${qualificationId}/nsi-interrelations`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`,
            }
        }).then((response) => {
            console.log(response.data.qualifications);

            commit('SET_AUTO_TRAJECTORY_QUALIFICATIONS', response.data.qualifications);
            commit('SET_STANDARD', response.data.standard);
        })
    },

    /*async SILENT_LOAD_KINDS({ commit, rootState }, area_id) {
        const query = area_id ? `?area_id=${area_id}` : ''

        await http.get(`/orks/kinds` + query, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_KINDS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },*/

    async LOAD_QUALIFICATIONS({ commit, rootState }, { area_id, kind_id, func_id, demanded, query_params }) {
        let query = kind_id ? `?kind_id=${kind_id}` : ''

        if (query.length === 0) query = query_params ? `?query=${query_params}` : ''
        else query += query_params ? `&query=${query_params}` : ''

        if (query.length === 0) query = area_id ? `?area_id=${area_id}` : ''
        else query += area_id ? `&area_id=${area_id}` : ''

        if (query.length === 0) query = func_id ? `?func_id=${func_id}` : ''
        else query += func_id ? `&func_id=${func_id}` : ''

        if (query.length === 0) query = demanded != null ? `?demanded=${demanded}` : ''
        else query += demanded ? `&demanded=${demanded}` : ''

        await httpWithLoader.get(`/orks/qualifications` + query, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_QUALIFICATIONS({ commit, rootState }, { query_params, area_id, kind_id, func_id, demanded }) {
        let query = kind_id ? `?kind_id=${kind_id}` : ''

        if (query.length === 0) query = query_params ? `?query=${query_params}` : ''
        else query += query_params ? `&query=${query_params}` : ''

        if (query.length === 0) query = area_id ? `?area_id=${area_id}` : ''
        else query += area_id ? `&area_id=${area_id}` : ''

        if (query.length === 0) query = kind_id ? `?kind_id=${kind_id}` : ''
        else query += kind_id ? `&kind_id=${kind_id}` : ''

        if (query.length === 0) query = func_id ? `?func_id=${func_id}` : ''
        else query += func_id ? `&func_id=${func_id}` : ''

        if (query.length === 0) query = demanded ? `?demanded=${demanded}` : ''
        else query += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/orks/qualifications` + query, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    
    async LOAD_ORKS({ commit, rootState }, qualification_id ) {
        const query = qualification_id  ? `?qualification_id=${qualification_id }` : ''

        await httpWithLoader.get(`/orks/orks` + query, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ORKS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_ORKS({ commit, rootState }, qualification_id ) {
        const query = qualification_id  ? `?qualification_id=${qualification_id }` : ''

        await http.get(`/orks/orks` + query, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ORKS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_INTERRELATIONS_BY_QUALIFICATION({ commit, rootState }, { cur_ork_id, qualification_id }) {
        await httpWithLoader.get(`/${ cur_ork_id }/qualifications/${ qualification_id }/trainings`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_INTERRELATIONS_BY_QUALIFICATION', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_WORK_FUNCTIONS_BY_QUERY({ commit, rootState }, { query, demanded }) {
        let queryS = query ? `?query=${query}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/filter-work-functions` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_WORK_FUNCTIONS_WITH_AREA_KIND_QUAL({ commit, rootState }, {str, area_id, kind_id, qual_id, demanded}) {
        let query = str ? `?query=${str}` : ''

        if (query.length === 0) query = area_id ? `?area_id=${area_id}` : ''
        else query += area_id ? `&area_id=${area_id}` : ''

        if (query.length === 0) query = kind_id ? `?kind_id=${kind_id}` : ''
        else query += kind_id ? `&kind_id=${kind_id}` : ''

        if (query.length === 0) query = qual_id ? `?qual_id=${qual_id}` : ''
        else query += qual_id ? `&qual_id=${qual_id}` : ''

        if (query.length === 0) query = demanded ? `?demanded=${demanded}` : ''
        else query += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/filter-work-functions${ query }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_ALL_WORK_FUNCTIONS({ commit, rootState }) {
        await httpWithLoader.get(`/filter-all-work-functions`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_KINDS_BY_QUERY({ commit, rootState }, { query, demanded }) {
        let queryS = query ? `?query=${query}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await httpWithLoader.get(`/filter-kinds` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_KINDS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_ALL_KINDS({ commit, rootState }) {
        await httpWithLoader.get(`/filter-all-kinds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_KINDS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_KINDS_BY_FUNC({ commit, rootState }, { func_id, demanded} ) {
        let queryS = func_id ? `?func_id=${func_id}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/filter-kinds-by-function` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            let tempArr = [];
            let uniqIds = [];

            for (const el of response.data) {
                if (!uniqIds.includes(el.id)) {
                    tempArr.push(el);
                    uniqIds.push(el.id);
                }
            }

            commit('SET_KINDS', tempArr)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_AREAS_BY_FUNC({ commit, rootState }, { func_id, demanded }) {
        let queryS = func_id ? `?func_id=${func_id}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/filter-areas-by-function` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            /*let resNotEmptyAreas = [];

            for (const area of response.data) {
                for (const notEmptyArea of notEmptyAreas) {
                    if (notEmptyArea.id === area.id) {
                        resNotEmptyAreas.push(area);
                        break;
                    }
                }
            }*/

            let tempArr = [];
            let uniqIds = [];

            for (const el of response.data) {
                if (!uniqIds.includes(el.id)) {
                    tempArr.push(el);
                    uniqIds.push(el.id);
                }
            }

            commit('SET_AREAS', tempArr)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_KINDS_BY_AREA({ commit, rootState }, { area_id, demanded }) {
        let queryS = area_id ? `?area_id=${area_id}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/filter-kinds-by-area` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            let tempArr = [];
            let uniqIds = [];

            for (const el of response.data) {
                if (!uniqIds.includes(el.id)) {
                    tempArr.push(el);
                    uniqIds.push(el.id);
                }
            }

            commit('SET_KINDS', tempArr)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_WORK_FUNCTIONS_BY_AREA({ commit, rootState }, area_id) {
        await httpWithLoader.get(`/filter-functions-by-area?area_id=${ area_id }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_AREAS_BY_KIND({ commit, rootState }, { kind_id, demanded }) {
        let queryS = kind_id ? `?kind_id=${kind_id}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await httpWithLoader.get(`/filter-areas-by-kind` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            /*let resNotEmptyAreas = [];

            for (const area of response.data) {
                for (const notEmptyArea of notEmptyAreas) {
                    if (notEmptyArea.id === area.id) {
                        resNotEmptyAreas.push(area);
                        break;
                    }
                }
            }*/

            let tempArr = [];
            let uniqIds = [];

            for (const el of response.data) {
                if (!uniqIds.includes(el.id)) {
                    tempArr.push(el);
                    uniqIds.push(el.id);
                }
            }

            commit('SET_AREAS', tempArr)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_AREAS_BY_QUAL({ commit, rootState }, { qual_id, demanded } ) {
        let queryS = qual_id ? `?qual_id=${qual_id}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/filter-areas-by-qual` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            /*let resNotEmptyAreas = [];

            for (const area of response.data) {
                for (const notEmptyArea of notEmptyAreas) {
                    if (notEmptyArea.id === area.id) {
                        resNotEmptyAreas.push(area);
                        break;
                    }
                }
            }*/

            let tempArr = [];
            let uniqIds = [];

            for (const el of response.data) {
                if (!uniqIds.includes(el.id)) {
                    tempArr.push(el);
                    uniqIds.push(el.id);
                }
            }

            commit('SET_AREAS', tempArr)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_KINDS_BY_QUAL({ commit, rootState }, { qual_id, demanded }) {
        let queryS = qual_id ? `?qual_id=${qual_id}` : ''

        if (queryS.length === 0) queryS = demanded ? `?demanded=${demanded}` : ''
        else queryS += demanded ? `&demanded=${demanded}` : ''

        await http.get(`/filter-kinds-by-qual` + queryS, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            let tempArr = [];
            let uniqIds = [];

            for (const el of response.data) {
                if (!uniqIds.includes(el.id)) {
                    tempArr.push(el);
                    uniqIds.push(el.id);
                }
            }

            commit('SET_KINDS', tempArr)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async SILENT_LOAD_WORK_FUNCTIONS_BY_KIND({ commit, rootState }, kind_id) {
        await http.get(`/filter-functions-by-kind?kind_id=${ kind_id }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_WORK_FUNCTIONS', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
